/* Yukon Bags - Corporate FAQ
   Search, topic filters, accordion, topic counts, sticky filter bar and FAQPage schema.
   Works across all corporate-faq-* sections on the page and re-initialises in the theme editor. */
(function () {
  if (window.__yukonFaqLoaded) return;
  window.__yukonFaqLoaded = true;

  var controller = null;

  var SYNONYMS = {
    moq: ['minimum'], minimum: ['moq'], min: ['minimum'],
    engrave: ['engraving', 'laser'], engraved: ['engraving', 'laser'], engraving: ['laser'], etch: ['laser', 'engraving'],
    emboss: ['deboss'], embossing: ['deboss'], debossing: ['deboss'], stamp: ['deboss', 'die'],
    branding: ['logo', 'personalization'], brand: ['logo'], customize: ['personalization', 'logo'], custom: ['personalization', 'logo'],
    personalise: ['personalization'], personalize: ['personalization'],
    artwork: ['logo', 'file', 'vector'], file: ['artwork', 'vector'], vector: ['artwork', 'file'],
    proof: ['mockup', 'approval'], mockup: ['proof'],
    rush: ['deadline', 'lead', 'fast'], urgent: ['deadline', 'rush'], deadline: ['lead', 'rush'], fast: ['rush', 'lead'], turnaround: ['lead', 'processing'],
    delivery: ['shipping', 'transit'], ship: ['shipping'], shipping: ['delivery'], freight: ['shipping'],
    price: ['pricing', 'cost', 'discount', 'quote'], pricing: ['price', 'discount'], cost: ['price', 'pricing'],
    bulk: ['volume', 'quantity', 'discount'], discount: ['bulk', 'volume'], wholesale: ['bulk', 'volume'],
    returns: ['return', 'refund'], return: ['refund'], refund: ['return'],
    water: ['wet', 'resistant'], clean: ['care'], care: ['clean', 'condition'],
    invoice: ['payment', 'wire'], pay: ['payment'], tax: ['exempt', 'duties'], duties: ['tax', 'customs'], customs: ['duties'],
    colour: ['color'], color: ['colour'], box: ['packaging'], packaging: ['box', 'gift']
  };
  var STOP = { a:1, an:1, the:1, is:1, are:1, do:1, does:1, can:1, i:1, we:1, you:1, my:1, our:1, your:1, to:1, of:1, for:1, on:1, in:1, and:1, or:1, it:1, how:1, what:1, which:1, with:1, be:1, me:1, us:1, will:1, if:1 };

  function normalize(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9%$.\-\s]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function highlight(el, terms) {
    if (!terms.length) return;
    var re = new RegExp('(' + terms.map(escapeRe).join('|') + ')', 'gi');
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (tn) {
      var v = tn.nodeValue; re.lastIndex = 0;
      if (!re.test(v)) return;
      re.lastIndex = 0;
      var frag = document.createDocumentFragment(), last = 0, m;
      while ((m = re.exec(v))) {
        frag.appendChild(document.createTextNode(v.slice(last, m.index)));
        var mk = document.createElement('mark'); mk.textContent = m[0]; frag.appendChild(mk);
        last = m.index + m[0].length;
      }
      frag.appendChild(document.createTextNode(v.slice(last)));
      tn.parentNode.replaceChild(frag, tn);
    });
  }

  function init() {
    if (controller) controller.abort();
    controller = window.AbortController ? new AbortController() : null;
    var opts = controller ? { signal: controller.signal } : false;

    var search = document.querySelector('.yf-search__input');
    var clear = document.querySelector('.yf-search__clear');
    var countEls = [].slice.call(document.querySelectorAll('[data-yf-count]'));
    var noResults = document.querySelector('.yf-noresults');
    var items = [].slice.call(document.querySelectorAll('.yf-item'));
    var categories = [].slice.call(document.querySelectorAll('.yf-category'));
    var filters = [].slice.call(document.querySelectorAll('.yf-filter__btn'));
    var activeFilter = 'all';
    if (!items.length) return;

    /* keep the original markup so highlights can be undone */
    items.forEach(function (item) {
      var q = item.querySelector('.yf-item__qtext'), a = item.querySelector('.yf-item__inner');
      if (q && !q.__orig) q.__orig = q.innerHTML;
      if (a && !a.__orig) a.__orig = a.innerHTML;
    });

    /* counts: hero total, topic cards */
    countEls.forEach(function (el) { el.textContent = items.length; });
    [].slice.call(document.querySelectorAll('[data-yf-topic-count]')).forEach(function (el) {
      var id = el.getAttribute('data-yf-topic-count');
      el.textContent = pad(items.filter(function (i) { return i.getAttribute('data-category') === id; }).length);
    });

    /* accordion */
    function setOpen(item, open) {
      var btn = item.querySelector('.yf-item__q'), ans = item.querySelector('.yf-item__a');
      if (!btn || !ans) return;
      btn.setAttribute('aria-expanded', String(open));
      ans.hidden = !open;
    }
    items.forEach(function (item) {
      var btn = item.querySelector('.yf-item__q');
      if (btn) btn.addEventListener('click', function () { setOpen(item, btn.getAttribute('aria-expanded') !== 'true'); }, opts);
    });

    [].slice.call(document.querySelectorAll('[data-yf-copy]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = location.origin + location.pathname + '#' + btn.getAttribute('data-yf-copy');
        var label = btn.textContent;
        var done = function (ok) { btn.textContent = ok ? 'Link copied' : url; setTimeout(function () { btn.textContent = label; }, 2000); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(function () { done(true); }, function () { done(false); });
        else done(false);
      }, opts);
    });

    function tokensOf(raw) {
      return normalize(raw).split(' ').filter(function (t) { return t && !STOP[t]; });
    }

    function apply() {
      var raw = search ? search.value.trim() : '';
      var tokens = tokensOf(raw);
      var visible = 0, shown = [];
      var hlTerms = [];
      tokens.forEach(function (t) { hlTerms.push(t); (SYNONYMS[t] || []).forEach(function (s) { hlTerms.push(s); }); });

      items.forEach(function (item) {
        var inCategory = activeFilter === 'all' || item.getAttribute('data-category') === activeFilter;
        var hay = item.__hay || (item.__hay = normalize(item.getAttribute('data-search') || ''));
        var matches = tokens.every(function (t) {
          if (hay.indexOf(t) > -1) return true;
          return (SYNONYMS[t] || []).some(function (s) { return hay.indexOf(s) > -1; });
        });
        var show = inCategory && matches;
        item.classList.toggle('yf-hidden', !show);
        item.classList.toggle('is-match', show && raw.length > 0);
        var q = item.querySelector('.yf-item__qtext'), a = item.querySelector('.yf-item__inner');
        if (q) q.innerHTML = q.__orig;
        if (a) a.innerHTML = a.__orig;
        if (show) {
          visible++; shown.push(item);
          if (raw) { if (q) highlight(q, hlTerms); if (a) highlight(a, hlTerms); }
        }
      });

      categories.forEach(function (cat) {
        var any = [].slice.call(cat.querySelectorAll('.yf-item')).some(function (i) { return !i.classList.contains('yf-hidden'); });
        cat.classList.toggle('yf-hidden', !any);
      });

      countEls.forEach(function (el) { el.textContent = visible; });
      if (clear) clear.hidden = !raw;
      if (noResults) noResults.hidden = visible > 0;

      if (raw) {
        items.forEach(function (i) { setOpen(i, false); });
        shown.slice(0, 3).forEach(function (i) { setOpen(i, true); });
      }
    }

    /* space taken at the top of the screen by the theme header and our filter bar */
    function topOffset() {
      var barEl = document.querySelector('.yf-filter');
      var v = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--yf-sticky-top'), 10) || 0;
      return v + (barEl ? barEl.offsetHeight : 0) + 16;
    }
    function scrollToFaq(target) {
      if (!target) return;
      var head = target.querySelector('.yf-section-head') || target;
      var go = function (smooth) {
        var y = head.getBoundingClientRect().top + window.pageYOffset - topOffset();
        window.scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto' });
      };
      go(true);
      /* the theme header can slide in while scrolling up; correct once the scroll settles */
      var fix = function () {
        var gap = head.getBoundingClientRect().top - topOffset();
        if (Math.abs(gap) > 4) go(false);
      };
      if ('onscrollend' in window) window.addEventListener('scrollend', function once() { window.removeEventListener('scrollend', once); setTimeout(fix, 60); });
      else setTimeout(fix, 700);
    }
    var announcer = document.querySelector('[data-yf-announce]');
    function announce(text) { if (announcer) { announcer.textContent = ''; setTimeout(function () { announcer.textContent = text; }, 30); } }
    function setFilter(id) {
      activeFilter = id;
      filters.forEach(function (f) {
        var on = f.getAttribute('data-filter') === id;
        f.classList.toggle('is-active', on);
        f.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) {
          var strip = f.parentNode;
          var left = f.offsetLeft - (strip.clientWidth - f.offsetWidth) / 2;
          if (strip.scrollTo) strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' }); else strip.scrollLeft = left;
        }
      });
    }
    function announceFilter() {
      var btn = filters.filter(function (f) { return f.getAttribute('data-filter') === activeFilter; })[0];
      var n = items.filter(function (i) { return !i.classList.contains('yf-hidden'); }).length;
      announce((btn ? btn.textContent.trim() : 'All topics') + ': ' + n + (n === 1 ? ' answer' : ' answers') + ' shown');
    }
    function firstCategory() { return categories.filter(function (c) { return !c.classList.contains('yf-hidden'); })[0]; }

    if (search) {
      var t;
      search.addEventListener('input', function () { clearTimeout(t); t = setTimeout(apply, 80); }, opts);
      search.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { search.value = ''; apply(); }
        if (e.key === 'Enter') { e.preventDefault(); apply(); scrollToFaq(firstCategory()); }
      }, opts);
    }
    if (clear) clear.addEventListener('click', function () { search.value = ''; apply(); search.focus(); }, opts);

    [].slice.call(document.querySelectorAll('[data-yf-query]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        search.value = btn.getAttribute('data-yf-query');
        setFilter('all'); apply(); scrollToFaq(firstCategory());
      }, opts);
    });
    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setFilter(btn.getAttribute('data-filter')); apply(); announceFilter();
        if (activeFilter !== 'all') scrollToFaq(document.getElementById(activeFilter));
        else scrollToFaq(firstCategory());
      }, opts);
    });
    [].slice.call(document.querySelectorAll('[data-yf-jump]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-yf-jump');
        if (search) search.value = '';
        setFilter(id); apply(); announceFilter(); scrollToFaq(document.getElementById(id));
      }, opts);
    });

    /* sticky filter bar: fixed while the FAQ list is on screen */
    var slot = document.querySelector('.yf-filter-slot');
    var bar = slot && slot.querySelector('.yf-filter');
    if (slot && bar) {
      var baseTop = parseInt(slot.getAttribute('data-sticky-top') || '0', 10) || 0;
      var top = baseTop;
      /* the theme's header may stick to the top when scrolling: sit the bar right below it */
      var headerBottom = function () {
        var max = 0;
        var cands = document.querySelectorAll('header, .site-header, #shopify-section-header, .shopify-section-group-header-group, [class*="header"][class*="sticky"], [class*="header"][class*="stuck"]');
        for (var i = 0; i < cands.length; i++) {
          var el = cands[i];
          if (el.closest('.yf')) continue;
          var pos = getComputedStyle(el).position;
          if (pos !== 'fixed' && pos !== 'sticky') continue;
          var r = el.getBoundingClientRect();
          if (r.top <= 1 && r.bottom > 0 && r.height < 320 && r.bottom > max) max = r.bottom;
        }
        return Math.round(max);
      };
      var setTop = function () {
        var t = Math.max(baseTop, headerBottom());
        if (t !== top || !document.documentElement.style.getPropertyValue('--yf-sticky-top')) {
          top = t;
          document.documentElement.style.setProperty('--yf-sticky-top', top + 'px');
        }
      };
      var onScroll = function () {
        setTop();
        var last = categories.filter(function (c) { return !c.classList.contains('yf-hidden'); }).pop() || slot;
        var h = bar.offsetHeight;
        var fixed = slot.getBoundingClientRect().top <= top && last.getBoundingClientRect().bottom > top + h;
        if (fixed !== bar.classList.contains('is-fixed')) {
          bar.classList.toggle('is-fixed', fixed);
          slot.style.minHeight = fixed ? h + 'px' : '';
        }
      };
      var recheck;
      var onScrollAll = function () {
        onScroll();
        clearTimeout(recheck);
        recheck = setTimeout(onScroll, 450); /* catches the header's slide-in animation */
      };
      window.addEventListener('scroll', onScrollAll, controller ? { passive: true, signal: controller.signal } : { passive: true });
      window.addEventListener('resize', onScroll, opts);
      onScroll();
    }

    /* FAQPage schema built from what is on the page, so it never goes stale */
    var old = document.getElementById('yf-faq-schema');
    if (old) old.parentNode.removeChild(old);
    /* when the theme already outputs FAQPage microdata from Liquid, don't add a second copy */
    var serverSchema = document.querySelector('[itemtype="https://schema.org/FAQPage"] [itemtype="https://schema.org/Question"]');
    if (!serverSchema) {
    var schema = {
      '@context': 'https://schema.org', '@type': 'FAQPage',
      mainEntity: items.map(function (item) {
        var q = item.querySelector('.yf-item__qtext'), a = item.querySelector('.yf-item__inner');
        return { '@type': 'Question', name: (q ? q.textContent : '').trim(),
          acceptedAnswer: { '@type': 'Answer', text: (a ? a.__orig.replace(/<[^>]+>/g, ' ') : '').replace(/\s+/g, ' ').trim() } };
      })
    };
    var s = document.createElement('script');
    s.type = 'application/ld+json'; s.id = 'yf-faq-schema'; s.textContent = JSON.stringify(schema);
    document.head.appendChild(s);
    }

    apply();

    /* deep link: /pages/...#question-handle opens that answer */
    var hash = decodeURIComponent((location.hash || '').slice(1));
    var target = hash && document.getElementById(hash);
    if (target && target.classList.contains('yf-item')) {
      setOpen(target, true);
      setTimeout(function () { window.scrollTo(0, target.getBoundingClientRect().top + window.pageYOffset - topOffset()); }, 60);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { setTimeout(init, 0); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target && e.target.closest && e.target.closest('.yf-item');
    if (item) { var b = item.querySelector('.yf-item__q'); if (b) { b.setAttribute('aria-expanded', 'true'); item.querySelector('.yf-item__a').hidden = false; } }
  });
})();